import ConfirmOnClick from "../ConfirmOnClick";
import DangerButton from "../Button/DangerButton";

export default ConfirmOnClick(DangerButton);
